import { Injectable } from '@angular/core';
import { FuseLoadingService } from '@fuse/services/loading';
import { GrpcEvent, GrpcMessage, GrpcRequest } from '@ngx-grpc/common';
import { GrpcHandler, GrpcInterceptor } from '@ngx-grpc/core';
import { Observable, defer, finalize } from 'rxjs';

@Injectable()
export class GrpcLoadingInterceptor implements GrpcInterceptor {
  handleRequestsAutomatically: boolean;

  /** Paths de streaming que no deben activar la barra de carga global */
  private readonly excludedPaths: string[] = [
    '/portal_alpaca_account.PortalAlpacaAccountGrpcService/StreamFundingPrice',
  ];

  constructor(private _fuseLoadingService: FuseLoadingService) {
    // Subscribe to the auto
    this._fuseLoadingService.auto$.subscribe(value => {
      this.handleRequestsAutomatically = value;
    });
  }

  intercept<Q extends GrpcMessage, S extends GrpcMessage>(
    request: GrpcRequest<Q, S>,
    next: GrpcHandler,
  ): Observable<GrpcEvent<S>> {
    // If the Auto mode is turned off, do nothing
    if (!this.handleRequestsAutomatically) {
      return next.handle(request);
    }

    // Excluir paths de streaming que nunca finalizan
    if (this.excludedPaths.includes(request.path)) {
      return next.handle(request);
    }

    // `defer` hace que el `_setLoadingStatus(true)` corra SOLO cuando la petición se
    // suscribe realmente, emparejado con el `finalize`. Si fuera eager en el cuerpo de
    // intercept(), un observable construido-pero-no-suscrito (ej. el forkJoin de
    // `dollarChartCurrencyIds$` en CurrencyIndicatorsService) deja un `true` sin su
    // `false` → el _urlMap queda con una entrada huérfana y la barra de carga se pega.
    return defer(() => {
      this._fuseLoadingService._setLoadingStatus(true, request.path);
      return next.handle(request).pipe(
        finalize(() => {
          // Set the status to false if there are any errors or the request is completed
          this._fuseLoadingService._setLoadingStatus(false, request.path);
        }),
      );
    });
  }
}
